import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { reduxForm } from 'antd-form-redux';
import { Form, Input, Icon, Button } from 'antd';
import { notificacao } from '../master-page/redux/notificacao';

export class FormRegistrar extends Component {
  static propTypes = {
    acessoSistema: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { form } = this.props;
    form.validateFields((err, values) => {
      if (err)
        return;

      this.props.actions.registrar(values, (action) => {
        if (action === 'ACESSO_SISTEMA_REGISTRAR_SUCCESS') {
          if (this.props.acessoSistema.registro.message) {
            notificacao('error', this.props.acessoSistema.registro.message);
          } else {
            notificacao('success', 'EGS Ticket Registro', 'Eviamos um email de confirmação do seu cadastro. Verifique a sua caixa de email.', 10);
          }
        } else {
          const { error } = this.props.acessoSistema.registrarError.response.data;
          console.error(error);
          notificacao('error', error.message);
        }
      })
    })
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="acesso-sistema-form-registrar">
        <Form onSubmit={this.handleSubmit}>
          <Form.Item>
            {getFieldDecorator('nomeCompleto', {
              rules: [{ required: true, message: 'Campo obrigatório!' }],
            })(
              <Input prefix={<Icon type="user" style={{ fontSize: 13 }} />} placeholder="Nome completo" />
            )}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator('email', {
              rules: [{ required: true, message: 'Campo obrigatório!' }],
            })(
              <Input prefix={<Icon type="mail" style={{ fontSize: 13 }} />} placeholder="Email" />
            )}
          </Form.Item>
          <Form.Item>
            <Button block type="primary" htmlType="submit" loading={this.props.acessoSistema.registrarPending} >
              <Icon type="login" />
              <span>Registrar</span>
            </Button>
          </Form.Item>
        </Form>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    acessoSistema: state.acessoSistema,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

FormRegistrar = reduxForm({
  form: 'Login-Registro',
})(FormRegistrar);

FormRegistrar = connect(
  mapStateToProps,
  mapDispatchToProps
)(FormRegistrar);

export default FormRegistrar;



// WEBPACK FOOTER //
// ./src/features/acesso-sistema/FormRegistrar.js